import React from "react";

function MedalCeremonyGraduateeCard(props) {
    const getImageName = (path) => {
        const filename = path.split('/').pop(); 
        const [titlePart] = filename.split(/\.\w{8,}\./);
        return titlePart.replace(/\.[^/.]+$/, ""); 
    };


    return (
        <div class="card" style={{width: "18rem", margin: "1%"}}>
            <div class="card-body">
                <h5 class="card-title">{props.username}</h5>
                <div className=" mb-2 d-flex justify-content-center position-relative">
                    <img src={props.image} class="card-img-top img-fluid rounded" alt="Graduatee" style={{
                                width: "100%",
                                height: "auto", 
                                objectFit: "fill",
                                margin: "0 auto",
                                border: "2px solid gold",
                            }} />
                    <div className="overlay-text position-absolute top-50 start-50 translate-middle text-white text-center">
                        <p>{getImageName(props.image)}</p>
                    </div>
                </div>
                {props.tags.map((tag, index) => (
                    <span key={index} className="badge bg-success me-1 mb-1">
                        {tag}
                    </span>
                ))}
                
            </div>
        </div>
    );
}

export default MedalCeremonyGraduateeCard;